import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToastComponent, ToastMessage } from '@ajgre/toolkit';
import { selectToastMessages, toastRemove } from '@cmi/store/toast';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private store = inject<Store<ToastMessage[]>>(Store);

  toastMessages$!: Observable<ToastMessage[]>;

  ngOnInit() {
    this.toastMessages$ = this.store.select(selectToastMessages);
  }

  onRemoveToast(toastMessage: ToastMessage) {
    this.store.dispatch(toastRemove({ toastMessage }));
  }
}
